import { apiJS } from "@/store/api";

const permissionCacheApi = apiJS.injectEndpoints({
    endpoints: (builder) => ({
        resetPermissionCache: builder.mutation<void, void>({
            query: () => ({
                url: "permission/cache/reset",
                method: "POST",
            }),
        }),
    }),
});

export const { useResetPermissionCacheMutation } = permissionCacheApi;
